import { lazy } from 'react';

import { Loadable } from '@trendiolive/trendio-selfcare-ui-kit';

import InitLayout from 'layout/Init';

const Init = Loadable(lazy(() => import('pages/init/init')));
const MerchantSelect = Loadable(lazy(() => import('pages/init/merchant-select')));

const InitRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <InitLayout />,
      children: [
        {
          path: '/',
          element: <Init />
        },
        {
          path: 'init',
          element: <Init />
        },
        {
          path: 'merchant-select',
          element: <MerchantSelect />
        }
      ]
    }
  ]
};

export default InitRoutes;
